jQuery(document).ready(function($) {

    var $billingDepartment = $('#billing_department');
    var $billingDistrict = $('#billing_district');

    if ($billingDepartment.length && $billingDistrict.length) {
        var selectedDepartmentId = $billingDepartment.data('selected-department');
        var departmentOptions = $billingDepartment.data('options-html');

        $billingDistrict.on('change', function() {
            var selectedDistrict = $(this).val();

            var hasMatch = false;

            if (departmentOptions) {
                $billingDepartment.html('<option value="">' +
                    'Välj en avdelning' +
                    '</option>' +
                    departmentOptions);
            }

            $('#billing_department option').each(function() {
                var departmentDistrict = $(this).data('district');

                if (departmentDistrict ==
                    selectedDistrict ||
                    $(this).val() ==
                    '') {
                    $(this).show();

                    hasMatch = true;
                } else {
                    $(this).hide();
                }
            });

            if (hasMatch) {
                $billingDepartment.find('option[value=""]').hide();
            } else {
                $billingDepartment.find('option[value=""]').show();
            }

            $billingDepartment.val('');
        });

        $billingDistrict.trigger('change');

        if (selectedDepartmentId) {
            $billingDepartment.val(selectedDepartmentId);
        }
    }

});
//# sourceMappingURL=checkout-district-department.js.map
